<template>
    <div class="taxi-order-info">
        <div :class="[taxiOrderInfo.status>4?'taxi-bill':'taxi-bill active']">
            <div class="taxi-bill-body">
                <div class="bill-body-top">
                    <div class="bill-body-top-left">
                        <div>{{taxiOrderInfo.startTime}}</div>
                    </div>
                    <div class="bill-body-top-right">
                        <div class="point-of-departure">
                            <div class="address-icon">
                                <img src="../assets/start-add.png" v-if="taxiOrderInfo.status > 4">
                                <img src="../assets/start-n.png" v-else>
                            </div>
                            <div class="detailed-address">
                                <div class="detailed-address-ac">{{taxiOrderInfo.boardingPoint}}</div>
                                <div class="detailed-address-nc"></div>
                                <div :class="[taxiOrderInfo.status > 4?'taxi-bill-left-line':'taxi-bill-left-line active']"></div>
                            </div>
                        </div>
                        <div class="to-destination">
                            <div class="address-icon">
                                <img src="../assets/end-add.png" v-if="taxiOrderInfo.status > 4">
                                <img src="../assets/end-n.png" v-else>
                            </div>
                            <div class="detailed-address">
                                <div class="detailed-address-ac">{{taxiOrderInfo.getoffPoint}}</div>
                                <div class="detailed-address-nc"></div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="order-info-body">
            <div class="order-info-progress">
                <template v-if="taxiOrderInfo.status === 5">
                    <div class="apply-type-icon">
                        <img src="../assets/cancel.png">
                    </div>
                </template>
                <template v-else>
                    <div class="apply-type-icon">
                        <img src="../assets/sub-yes.png" v-if="taxiOrderInfo.status > 0">
                        <img src="../assets/sub-no.png" v-else>
                    </div>

                    <img class="connect-icon" src="../assets/connect-line.jpg">

                    <div class="apply-type-icon">
                        <img src="../assets/serve-yes.png" v-if="taxiOrderInfo.status > 1">
                        <img src="../assets/serve-no.png" v-else>
                    </div>

                    <img class="connect-icon" src="../assets/connect-line.jpg">

                    <div class="apply-type-icon">
                        <img src="../assets/taxi-yes.png" v-if="taxiOrderInfo.status > 2">
                        <img src="../assets/taxi-no.png" v-else>
                    </div>

                    <img class="connect-icon" src="../assets/connect-line.jpg">

                    <div class="apply-type-icon">
                        <img src="../assets/order-yes2.png" v-if="taxiOrderInfo.status > 3">
                        <img src="../assets/order-no2.png" v-else>
                    </div>
                </template>
            </div>
            <div class="order-info-record">
                <div :class="[index?'order-message-line':'order-message-line active']"
                     v-for="(item,index) in taxiOrderInfo.progress" :key="index">
                    <span>
                         <img src="../assets/dot-h.png" v-if="index">
                         <img src="../assets/dot-l.png" v-else>
                    </span>
                    <span>{{item}}</span>
                </div>
            </div>
        </div>
        <div class="order-info-message">
            <div class="consignee-information">
                <div class="consignee-information-title">联系人信息</div>
                <div class="consignee-information-box">
                    <div class="consignee-name">{{taxiOrderInfo.realName}}</div>
                    <div class="consignee-info">{{taxiOrderInfo.mobile}}</div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                taxiOrderInfo:''
            }
        },
        created:function () {
            let oid = this.$route.query.id;
            this.$axios.get("/api/service/Rent/info/"+oid).then(res => {
                if(!res.data.code){
                    this.taxiOrderInfo = res.data.data;
                    //this.$store.commit('setTaxiOrderInfo', res.data.data);
                }
            }).catch(error => {
                console.log(error);
                // this.$router.push("/error")
            });
        },
    }
</script>
<style scoped>
    .order-info-message::before{
        content:" ";
        position:absolute;
        left:0;
        right:0;
        top:0;
        bottom:0;
        background-color:#f3f3f3;/* 颜色自定义 */
        z-index:-100;/* 突然想到个游戏，是男人就下100层。。。 */
    }
    .apply-type-icon img{
        width: 43px;
    }
    .taxi-order-info{
        padding-top: 20px;
    }
    .order-info-body{
        background-color: #fff;
        padding: 0 30px 8px;
    }
    .order-info-progress{
        padding-top: 25px;
        text-align: center;
        padding-bottom: 20px;
        border-bottom: 1px solid #e0e0e0;
    }
    .consignee-information{
        padding: 10px 27px 10px;
    }
    .order-info-progress .connect-icon{
        position: relative;
        top: -2px;
    }
    .order-info-record{
        padding: 10px 0;
    }
    .order-info-record img{
        width: 7px;position: relative;top: -2px;
    }
    .order-info-message{
        margin-top: 7px;
        background-color: #fff;
    }
    .taxi-bill{
        background-color: #fff;
        border-radius: 6px;
        box-shadow: 0 13px 24px #ebedf0;
        border-left: 5px solid #fff;
        margin: 0 20px 15px;
    }
    .taxi-bill.active{
        border-left: 5px solid #FFDC3A;
    }
    .taxi-bill-body{
        height: 100%;
    }
    .taxi-bill-line{
        height: 20px;
        position: relative;
        top: 60%;
        background: #d2d227;
    }
    .bill-body-middle div{
        display: inline-block;
    }
    .bill-round-left{
        height: 40px;
        width: 40px;
        border-radius: 20px;
        background: #ebedf0;
        position: relative;
        left: -20px;top: -13px;
    }
    .bill-round-right{
        height: 40px;
        width: 40px;
        float: right;
        background: #ebedf0;
        border-radius: 20px;
        position: relative;
        right: -20px;top: -13px;
    }
    .bill-body-middle{
        height: 15px;
        background: #cece66;
    }
    .order-message-line{
        font-size: 13px;color: #4a4a4a;padding-left: 10px;
    }
    .order-message-line.active{
        color: #FFDC3A;
    }
    .bill-body-top{
        padding: 20px 20px 0;
    }
    .bill-body-top-left{
        margin-bottom: 0.7rem;
    }
    .bill-body-top-right{
        position: relative;
    }
    .bill-body-bottom{
        padding: 20px;
        text-align: center;
        font-size: 1.2rem;
        font-weight: 600;
    }
    .address-icon{
        display: inline-block;
        padding: 0 3px;
        float: left;
        position: relative;
        z-index: 2;
        background-color: #fff;
    }
    .address-icon i{
        top:2px;margin-right: 8px;
    }
    .detailed-address{
        display: inline-block;width: 90%;position: relative;
    }
    .detailed-address div{
        word-wrap:break-word;
        word-break:normal;
    }
    .bill-body-top-left div{
        font-size: 14px;padding-left: 3px;
    }
    .bill-body-top-left span{
        font-size: 0.8rem;
        color: #999;
    }
    .point-of-departure{

    }
    .detailed-address-ac{
        font-size: 14px;
        color: #4a4a4a;
        margin-left: 6px;
        padding-bottom: 20px;
    }
    .detailed-address-nc{
        color: #999;
    }
    .taxi-bill .address-icon img{
        width: 12px;position: relative;
    }
    .to-destination .address-icon img{top: 1px}
    .point-of-departure .address-icon img{top: 1px;left: 1px}
    .taxi-order-info .taxi-bill-left-line img{
        width: 2px;margin-left: 8px;height: 20px;
    }
    .taxi-bill-left-line{
        width: 1px;
        border-right: 1px dashed #e7e5d9;
        height: 100%;
        left: -10px;
        top: 9px;
        position: absolute;
        z-index: 0;
    }
    .taxi-bill-left-line.active{
        border-right: 1px dashed #FFDC3A;
    }
</style>
